import { authFetch } from "~/services/fetch";

export async function getDevicesConnectedByDispatchGroups({
  dispatchGroupIds,
  deviceId,
  groupSetId,
  operationUnitId,
  agencyId
  // startDate,
  // finishDate,
}) {
  try {
    const { data } = await authFetch({
      url: '/statistics/devices-connected-by-dispatch-groups',
      method: 'POST',
      data: {
        dispatchGroupIds,
        deviceId,
        groupSetId,
        operationUnitId,
        agencyId
        // startDate,
        // finishDate,
      }
    })

    return data;
  } catch (error) {
    throw error
  }
}

export async function getDevicesConnectedByType({
  dispatchGroupIds,
  deviceId,
  groupSetId,
  operationUnitId,
  agencyId
  // startDate,
  // finishDate,
}) {
  try {
    const { data } = await authFetch({
      url: '/statistics/devices-connected-by-type',
      method: 'POST',
      data: {
        dispatchGroupIds,
        deviceId,
        groupSetId,
        operationUnitId,
        agencyId
        // startDate,
        // finishDate,
      }
    })

    return data;
  } catch (error) {
    throw error
  }
}